import { render, staticRenderFns } from "./TabUserDynamicTable.vue?vue&type=template&id=1b1d6c56&scoped=true&"
import script from "./TabUserDynamicTable.vue?vue&type=script&lang=js&"
export * from "./TabUserDynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d6c56",
  null
  
)

export default component.exports